/*
	onePredictiveSearch 2.0.0 Usage (Webpack)
	alyssa @onerockwell
	
	Please replace 'YourModuleCallName' with your module's call name, e.g. OneModal, MyModule, HelloWorld etc.
	
*/

// Import all dependencies here
import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

// import '../../styles/modules/yourModuleCallName.scss';

import SearchResultsTemp from '@/templates/template-onePredictiveSearchResults.html';

// Define the Backbone View here (Optional)
let OnePredictiveSearchView = Backbone.View.extend({
	
	initialize: function (settings) {
		var self = this;

		console.log('init predictive search module');

		self.initSearchResults();
		self.resetInput();
		self.closeResults();

	},

	events: {
		
	},

	initSearchResults: function() {
		return;
		var self = this;

		$('#SearchForm input').on('focus', function(){
			const q = $(this).val();

			if (!q && q == '') {
				$('.search-active-state').addClass('hide');
				$('.search-static-state').removeClass('hide');
			} else {
				$('.search-active-state').removeClass('hide');
				$('.search-static-state').addClass('hide');
			}
		});
		
		$('#SearchForm input').keyup(function(){
		    var q = $(this).val();
		    // console.log(q);

			$('.search-active-state button').prop('disabled', true)

			// Search Static State
			if(!q || q == '') {
				$(".predictive-search--search-template").empty()
				$('.search-active-state button').addClass('hide')
				$('.search-active-state button').prop('disabled', false)

				$('.search-active-state').addClass('hide')
				$('.search-static-state').removeClass('hide')
				return
			}

			// Search Active State
		    $.ajax('/search/suggest.json?q=' + q + '&section_id=predictive-search',{
				type: 'GET',
				dataType: 'json', // added data type
				success: function(response) {
					console.log(response);

					var productSuggestions = response.resources.results.products;
					var querySuggestions = response.resources.results.queries;
					var collectionSuggestions = response.resources.results.collections;
					var pageSuggestions = response.resources.results.pages;
					var articleSuggestions = response.resources.results.articles;

					$(".predictive-search--search-template").empty();

					// No Results
					if(!productSuggestions.length || !querySuggestions.length) {
						console.log('no results');
						$('.search-active-state button').addClass('hide')
						$('.search-active-state .no-results').removeClass('hide')
						
						$('.search-active-state .no-results .search-input').text(q)
						
						return
					}

					var content = self.buildTemplate({
						response: response,
						productSuggestions,
						querySuggestions,
						collectionSuggestions,
						pageSuggestions,
						articleSuggestions,
						searchPageResults: '#predictive-search'
					});

					self.$search = $('.predictive-search--search-template').append(content);

					$('.search-active-state .no-results').addClass('hide')

					$('.search-active-state button').removeClass('hide')
					$('.search-active-state button').prop('disabled', false)

					$('.search-active-state').removeClass('hide')
					$('.search-static-state').addClass('hide')
				}
		    });
		});
				
	},

	resetInput: function() {

		$('.reset__button').on('click', function(e){
			e.preventDefault();
			// console.log($(this).parent().find('input')[0].value);
			$(this).parent().find('input')[0].value = '';
			$(this).parent().find('input')[0].focus();
		});
	},

	closeResults: function() {
	  return;
	  document.addEventListener("click", function(e) {
        var inputForm = document.getElementById('SearchResult'),
          targetEl = e.target; // clicked element      
        do {
          if(targetEl == inputForm) {
            // This is a click inside, does nothing, just return.
            return;
          }
          // Go up the DOM
          targetEl = targetEl.parentNode;
        } while (targetEl);
        // This is a click outside.
        // $(".predictive-search--search-template").empty();
      });

	},

	buildTemplate: function (content, type) {
		var self = this,
			typeTemplate;
		
		switch(type) {
			case '':
				break;
			default:
				typeTemplate = SearchResultsTemp;
				break;
		};
		
		return typeTemplate({content: content});
	},
	
	destroy: function() {
		var self = this;
		self.undelegateEvents();
	}

});

// Define the module here 
let OnePredictiveSearch = {
	init: function (settings) {
		
		return new OnePredictiveSearchView(settings);
		
	}
}

// Output the module
export default OnePredictiveSearch;